import { render } from "./BoardOfDirectors.vue?vue&type=template&id=3317d158&scoped=true"
import script from "./BoardOfDirectors.vue?vue&type=script&lang=js"
export * from "./BoardOfDirectors.vue?vue&type=script&lang=js"

import "./BoardOfDirectors.vue?vue&type=style&index=0&id=3317d158&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3317d158"]])

export default __exports__